import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { downloadCSV,stopProcessCSV,statusCSV, generateCSV } from '../../../../../../jsx/reducers/paygAdmin/extract'
import Dialog  from '../../../commonModules/interface/Dialog';

import { Button, Grid , Box, LinearProgress,Typography, IconButton } from '@material-ui/core';
import DatePickerCustom from '../../../commonModules/interface/DatePickerCustom';


class StockExtractButton extends Component {
    state = { 
        data: "",
        url:"inventory/sales",
        list:[],
        loading: false,
        downloadProcessInventory: false,
        typeInfo: "",
        dataset: "",
        processID: "",
        progress: 0,
        itemDownloaded: 0,
        totalItemToDownload: 0,
        linkAvailable :false,
        start_date: new Date(),
        end_date: new Date(),

    }

    stopInventoryProcess = () => {
        this.setState({
            downloadProcessInventory: false,
            linkAvailable:false,
            itemDownloaded: 0,
            totalItemToDownload: 0
        })
        this.props.stopProcessCSV(this.state.processID)
    }

    openDateForm = (extract) => {
        this.setState({
            dateForm : true,
            currentExt: extract,
            typeInfo: extract,
        })
    }
    handleSubmitDateForm = () => {
        const { start_date, end_date, currentExt} = this.state;
        if (start_date && end_date && start_date < end_date) {
            let data = {
                start_date: this.state.start_date,
                end_date: this.state.end_date,
            }
            this.fetchDataStoreHouse(currentExt, data)

        } else {
            console.log("invalid dates");
            // this.notif('danger', "invalid dates")
        }
    }

    fetchStatus = (processID) => {
        this.props.statusCSV(processID).then( dataset => {
            console.log({dataset});
            console.log("[INFO] fetchStatus ", dataset);
            const normalise = 100*(dataset.actual / (dataset.total));
            console.log("[INFO] fetchStatus ", dataset.actual," /",dataset.total, " => ",normalise);

            this.setState({progress: normalise, itemDownloaded: dataset.actual, totalItemToDownload: dataset.total})

            if (dataset.status == "COMPLETED") {
                this.setState({linkAvailable: true, progress: 100, itemDownloaded: dataset.total })
            } else {
                setTimeout(() => {
                    this.fetchStatus(processID)
                    }, 3000);
            }
        }).catch( err => {
            console.log("[ERROR], fetchStatus, ",err)
        })
    }

    fetchDataStoreHouse = (info, dates) => {
        this.setState({downloadProcessInventory: true, typeInfo:info})
        this.props.generateCSV(info, dates, this.props.product_id).then(
            (processID) => {
                console.log("[INFO], fetchDataStoreHouse, ",processID)
                this.setState({processID :  processID })
                this.fetchStatus(processID)
            }
        ).catch(
            (err) => {
                console.log("[ERROR], fetchDataStoreHouse, ",err)
            }
        )
    }
     
    startDownload = (href, title) => {
        const link = document.createElement('a');
        link.href = "data:application/csv;charset=utf-8," + encodeURIComponent(href);
        link.setAttribute('download', title);

        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
    }

    handleDownloadInventory = () => {
        const processID = this.state.processID
        const type = this.state.typeInfo
        this.props.downloadCSV(processID,type)
        this.setState({
            downloadProcessInventory: false,
            linkAvailable:false,
            itemDownloaded: 0,
            totalItemToDownload: 0,
            dateForm : false,
            currentExt: "",
        })
    }

    render() {
        console.log('====================================');
        console.log("[STATE]", this.state);
        console.log('====================================');
        const { loading } = this.props;
        return (
            <Box p={1}>
                {this.props.icon ?
                    <IconButton 
                        onClick={() => this.fetchDataStoreHouse(this.props.extract)} 
                        disabled={loading}
                        {...this.props}
                    >
                        {this.props.icon}
                    </IconButton>
                :
                <Button 
                    onClick={() => this.fetchDataStoreHouse(this.props.extract)} 
                    disabled={loading}
                    {...this.props}
                >
                    {this.props.title}
                </Button>
                }
           
               
                {this.state.downloadProcessInventory &&
                    <Dialog
                        title="Extract Magasin Info"
                        block={true}
                        close={()=> this.stopInventoryProcess()}
                    >
                        <Box p={2}>
                            <Typography variant="caption" component="div" color="textSecondary">
                                Avancement {
                                    `${Math.round(this.state.progress)}%`
                                } ou {this.state.itemDownloaded} / {this.state.totalItemToDownload} 
                            </Typography>
                            {/* <CircularProgress variant="determinate" value={this.state.progress} />  */}
                            <LinearProgress variant="determinate" color="secondary" value={this.state.progress} />
                            { this.state.linkAvailable &&
                                <Box p={1}>
                                    <Button color="primary" onClick={this.handleDownloadInventory}>
                                        Download here
                                    </Button>
                                </Box>
                            }
                        </Box>
                    </Dialog>
                }
             
                {this.state.dateForm &&
                    <Dialog
                        submitAction={this.handleSubmitDateForm}
                        close={ () => this.setState({ dateForm: false, currentExt: "", titleDialog: "" }) }
                        submitTitle="Télécharger"
                        title="Periode"
                        block={true}
                    >
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={6} >
                                <DatePickerCustom
                                    required
                                    label="Du"
                                    handleChange={(date)=> this.setState({ start_date: date})}
                                    value={this.state.start_date}
                                    id="start_date"
                                    maxDate={this.state.end_date || new Date()}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                <DatePickerCustom
                                    required
                                    label="Au"
                                    handleChange={(date)=> this.setState({ end_date: date})}
                                    value={this.state.end_date}
                                    id="end_date"
                                    maxDate={new Date()}
                                    minDate={this.state.start_date || new Date()}
                                />
                            </Grid>
                        </Grid>
                    </Dialog>
                }
            </Box>
        );
    }
}

function mapStateToProps(state){
    return {
        loading: state.extract.fetching
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        generateCSV,
        statusCSV,
        stopProcessCSV,
        downloadCSV
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(StockExtractButton);